<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="visible"
    @close="hide"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-spin :spinning="loading">
      <a-form-model ref="form" :model="form" :rules="rules">
        <a-form-model-item label="菜单权限">
          <a-checkbox @change="handleCheckedTreeExpand($event)"> 展开/折叠 </a-checkbox>
          <a-checkbox @change="handleCheckedTreeNodeAll($event)"> 全选/全不选 </a-checkbox>
          <a-checkbox
            @change="handleCheckedTreeConnect($event)"
            :checked="form.menuCheckStrictly"
            :disabled="menuCheckedKeys.length > 0"
          >
            父子联动
            <a-tooltip>
              <template slot="title"> 当勾选项为空时方可切换模式， 可以点击"全不选"后再次切换。 </template>
              <a-icon type="question-circle-o" />
            </a-tooltip>
          </a-checkbox>
          <a-tree
            v-model="menuCheckedKeys"
            checkable
            :checkStrictly="!form.menuCheckStrictly"
            :expanded-keys="menuExpandedKeys"
            :auto-expand-parent="autoExpandParent"
            :tree-data="menuOptions"
            @check="onCheck"
            @expand="onExpandMenu"
            :replaceFields="defaultProps"
          />
        </a-form-model-item>
      </a-form-model>
    </a-spin>

    <div class="bottom-control">
      <a-space>
        <a-button
          type="primary"
          :loading="submitLoading"
          @click="submitForm"
          v-hasPermi="['ed423216bc32f1207aa8300b53bea16dc:0:c']"
          >保存</a-button
        >
        <a-button type="dashed" @click="hide">关闭</a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import { getModuleMenuList, addModuleMenu } from '@/api/system/module'
import { treeselect as menuTreeselect } from '@/api/system/menu'
import { message } from 'ant-design-vue'

export default {
  name: 'ModuleMenuDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      submitLoading: false,
      moduleId: undefined,
      formTitle: '模块菜单',
      menuExpandedKeys: [],
      autoExpandParent: false,
      menuCheckedKeys: [],
      halfCheckedKeys: [],
      menuOptions: [],
      form: {
        menuCheckStrictly: true,
      },
      rules: {},
      defaultProps: {
        children: 'children',
        title: 'label',
        key: 'id',
      },
    }
  },
  methods: {
    show(record) {
      this.moduleId = record.id
      this.formTitle = `模块菜单 - ${record.moduleName || ''}`
      this.visible = true
      this.reset()
      this.getMenuTreeselect()
    },
    hide() {
      this.visible = false
      this.reset()
    },
    reset() {
      this.menuExpandedKeys = []
      this.autoExpandParent = false
      this.menuCheckedKeys = []
      this.halfCheckedKeys = []
      this.menuOptions = []
      this.form = {
        menuCheckStrictly: true,
      }
    },
    onExpandMenu(expandedKeys) {
      this.menuExpandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    handleCheckedTreeExpand(value) {
      if (value.target.checked) {
        const treeList = this.menuOptions
        const expandedKeys = []
        const getAllKeys = (nodes) => {
          nodes.forEach((node) => {
            expandedKeys.push(node.id)
            if (node.children && node.children.length > 0) {
              getAllKeys(node.children)
            }
          })
        }
        getAllKeys(treeList)
        this.menuExpandedKeys = expandedKeys
      } else {
        this.menuExpandedKeys = []
      }
    },
    handleCheckedTreeNodeAll(value) {
      if (value.target.checked) {
        this.getAllMenuNode(this.menuOptions)
      } else {
        this.menuCheckedKeys = []
        this.halfCheckedKeys = []
      }
    },
    getAllMenuNode(nodes) {
      if (!nodes || nodes.length === 0) {
        return
      }
      nodes.forEach((node) => {
        this.menuCheckedKeys.push(node.id)
        if (node.children && node.children.length > 0) {
          this.getAllMenuNode(node.children)
        }
      })
    },
    handleCheckedTreeConnect(value) {
      this.form.menuCheckStrictly = !this.form.menuCheckStrictly
    },
    onCheck(checkedKeys, info) {
      if (!this.form.menuCheckStrictly) {
        let currentCheckedKeys = []
        if (info.checked) {
          currentCheckedKeys = currentCheckedKeys.concat(info.checked)
        }
        if (info.halfChecked) {
          currentCheckedKeys = currentCheckedKeys.concat(info.halfChecked)
        }
        this.menuCheckedKeys = currentCheckedKeys
      } else {
        this.halfCheckedKeys = info.halfCheckedKeys || []
        this.menuCheckedKeys = checkedKeys
      }
    },
    getMenuAllCheckedKeys() {
      return this.menuCheckedKeys.concat(this.halfCheckedKeys)
    },
    submitForm() {
      if (!this.menuCheckedKeys || this.menuCheckedKeys.length === 0) {
        message.warning('请至少选择一个菜单')
        return
      }
      this.submitLoading = true
      const menuIds = [...new Set(this.getMenuAllCheckedKeys())]
      const submitData = {
        moduleId: this.moduleId,
        menuIds: menuIds,
      }
      addModuleMenu(submitData)
        .then(() => {
          message.success('操作成功')
          this.hide()
          this.$emit('ok')
        })
        .catch((error) => {
          console.error('操作失败:', error)
          message.error('操作失败')
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    async getMenuTreeselect() {
      this.loading = true
      try {
        const response = await menuTreeselect()
        if (response && response.data) {
          this.menuOptions = response.data
          await this.loadModuleMenus()
        }
      } catch (error) {
        console.error('获取菜单树结构失败:', error)
        message.error('获取菜单树结构失败')
      } finally {
        this.loading = false
      }
    },
    async loadModuleMenus() {
      if (!this.moduleId) {
        return
      }
      try {
        const response = await getModuleMenuList(this.moduleId)
        if (response && response.data) {
          this.menuCheckedKeys = response.data.map((item) => item.menuId)
        } else {
          this.menuCheckedKeys = []
        }
      } catch (error) {
        console.error('获取模块菜单列表失败:', error)
        message.error('获取模块菜单列表失败')
        this.menuCheckedKeys = []
      }
    },
  },
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>
